import React, { useState } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useHotkeys } from 'react-hotkeys-hook';
import { glow } from './PlayerButton/glowAnimation';

const ANIMATION_DURATION_MS = 400;
const ANIMATION_DURATION_SEC = ANIMATION_DURATION_MS / 1000;

const GlowElement = styled.span<{ isAnimating: boolean }>`
  > * {
    animation: ${({ isAnimating }) =>
      isAnimating
        ? css`
            ${glow} ${ANIMATION_DURATION_SEC}s;
          `
        : 'none'};
  }
`;

export function withHighlight<P extends object>(
  Component: React.ComponentType<P>,
  keybinding: string,
): React.ComponentType<P> {
  const Highlighted = (props: P) => {
    const [isAnimating, setIsAnimating] = useState(false);

    useHotkeys(keybinding, () => {
      setIsAnimating(true);
      setTimeout(() => setIsAnimating(false), ANIMATION_DURATION_MS);
    });

    return (
      <GlowElement isAnimating={isAnimating}>
        <Component {...props} />
      </GlowElement>
    );
  };
  return Highlighted;
}
